import gsap from 'gsap'

export default class DepositView
{
    constructor(_options)
    {
        this.deposit = _options.deposit
        this.container = _options.factory.createDeposit(this.deposit)
        this.sync()
    }

    sync()
    {
        if(this.deposit.tree)
        {
            this.container.userData.tree.visible = this.deposit.remaining > 0
            this.container.userData.stump.visible = this.deposit.remaining === 0
            return
        }
        this.container.visible = this.deposit.revealed && this.deposit.remaining > 0
        const scale = 0.7 + 0.3 * (this.deposit.remaining / this.deposit.amount)
        this.container.scale.setScalar(scale)
    }

    reveal()
    {
        const scale = 0.7 + 0.3 * (this.deposit.remaining / this.deposit.amount)
        this.container.visible = true
        this.container.position.z = -1.6
        this.container.scale.setScalar(0.2)
        gsap.to(this.container.position, { z: 0, duration: 0.85, ease: 'back.out(2.2)' })
        gsap.to(this.container.scale, { x: scale, y: scale, z: scale, duration: 0.75, ease: 'back.out(2.5)' })
    }
}
